export enum AssessmentManagerStatus {
  Active = 0,
  Closed = 1
}

export enum AssessmentControlStatus {
  Active = 0,
  Closed = 1
}

export interface AssessmentManagerListItem {
  assessmentId: number;
  assessmentName: string;
  scopeSummary: string;
  startDate?: Date;
  endDate?: Date;
  lead?: any;
  status: AssessmentManagerStatus;
  year: number;
}

export interface AssessmentControlRow {
  assessmentControlId: number;
  projectControlItemId: number;
  controlId: string;
  controlShortName: string;
  controlCategory: string;
  status: AssessmentControlStatus;
  dueDate?: Date;
  assessorUserId?: number;
  assessor?: any;
}

export interface AssessmentManagerDetail {
  assessmentId: number;
  projectId: number;
  assessmentName: string;
  leadUserId?: number;
  lead?: any;
  startDate?: Date;
  endDate?: Date;
  status: AssessmentManagerStatus;
  year: number;
  controls: AssessmentControlRow[];
}

export interface AssessmentControlInput {
  assessmentControlId?: number;
  projectControlItemId: number;
  assessorUserId?: number;
  dueDate?: Date;
  status: AssessmentControlStatus;
}

export interface AssessmentManagerUpsertRequest {
  assessmentName: string;
  leadUserId?: number;
  startDate?: Date;
  endDate?: Date;
  status: AssessmentManagerStatus;
  year?: number;
  controls: AssessmentControlInput[];
}

export interface AssessmentControlPatchRequest {
  assessorUserId?: number;
  dueDate?: Date;
  status?: AssessmentControlStatus;
}
